// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__32z2-","rootSmall":"AddTileButton_rootSmall__goNti"};